'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var last = require('it-last');
var normaliseInputSingle = require('ipfs-core-utils/files/normalise-input-single');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var last__default = /*#__PURE__*/_interopDefaultLegacy(last);

function createAdd({addAll}) {
  async function add(entry, options = {}) {
    const result = await last__default["default"](addAll(normaliseInputSingle.normaliseInput(entry), options));
    if (result == null) {
      throw Error('Failed to add a file, if you see this please report a bug');
    }
    return result;
  }
  return add;
}

exports.createAdd = createAdd;
